import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import { loginUser, logoutUser } from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";

const Credential = (props) => {
  //http://localhost:6080/credential/{"clientAppId":1,"username":"imwoodie","password":"123456","companyId":"1","branchId":"1"}
  //http://localhost:6080/credential/%7B%22clientAppId%22%3A1%2C%22username%22%3A%22imwoodie%22%2C%22password%22%3A%22pkgroup%22%2C%22companyId%22%3A%221%22%2C%22branchId%22%3A%221%22%7D
  const dispatch = useDispatch();
  const param = useParams();
  const jsonData = JSON.parse(decodeURIComponent(param.data));
  

  const credential = {
    clientAppId: jsonData.clientAppId,
    username: jsonData.username,
    password: jsonData.password,
  };

  useEffect(() => {
    dispatch(loginUser(credential, props.router.navigate, `/dashboard/credential/${jsonData.companyId}/${jsonData.branchId}`));
  }, [dispatch]);

  return <></>;
};

export default withRouter(Credential);
